import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';

const PlanProfileTopHeader: React.FC = () => {
  const [t] = useTranslation('');
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top flex items-center justify-between">
        <h2 className="title flex">
          <span
            className="pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer"
            onClick={() => navigate(PATH.profile)}
          ></span>
          <span className="ml-3">{t('profile.plan_top_header')}</span>
        </h2>
      </div>
    </>
  );
};

export default PlanProfileTopHeader;
